import { Component } from '@angular/core';
import { ConfirmationModalService } from '../../services/confirmation-modal.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-invite-family-member',
  templateUrl: './invite-family-member.component.html',
  styleUrls: ['./invite-family-member.component.scss']
})
export class InviteFamilyMemberComponent {

    private sub = new Subscription();
    private _show: boolean = false;
    private _result: Promise<any>;

  constructor(private confirmationModalService: ConfirmationModalService) { }
  
    ngOnInit(): void {
      this.sub.add(
        this.confirmationModalService.getShowModal().subscribe(res => {
          this.show = res;
        })
      );
    }
    
     set show(value: boolean) {
    this._show = value;
  }

  get show() {
    return this._show;
  }


}
